var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "18px",
    viewBox: "0 0 11 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6964046,25.0038049 L28.7010242,18.2697561 C28.8938971,18.0847805 29,17.8374634 29,17.5737561 C29,17.3099024 28.8938971,17.0627317 28.7010242,16.8774634 L28.0872409,16.2877073 C27.8946724,16.1021463 27.6372549,16 27.36294,16 C27.0886251,16 26.831512,16.1021463 26.6387914,16.2877073 L18.2986754,24.3051707 C18.1051936,24.4910244 17.9992429,24.7393659 18,25.0033659 C17.9992429,25.2685366 18.1050414,25.5165854 18.2986754,25.7025854 L26.6310277,33.7122927 C26.8237484,33.8978537 27.0808615,34 27.3553286,34 C27.6296435,34 27.8867566,33.8978537 28.0796295,33.7122927 L28.6932606,33.1225366 C29.0925546,32.7386829 29.0925546,32.1138049 28.6932606,31.7300976 L21.6964046,25.0038049 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messenger---call-back",
    transform: "translate(-28.000000, -26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icVideoBack",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoBack);
export default __webpack_public_path__ + "static/media/icVideoBack.e3c98d3d556a31d4224b6794aab12407.svg";
export { ForwardRef as ReactComponent };